import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initRegistration from './initializers/Registration.js'

const initApplication = () => {
  initModal()
  initUser()
  initRegistration()
}

export default initApplication
